//This has to be used to get access to the navigation history 
// from components where the history passed by props is not possible. 
import { createBrowserHistory } from "history";
const customHistory = createBrowserHistory()
export default customHistory;